<div 
  [class.error]="(state() === 'error' || state() === 'alert' )"
  [class.information]="(state() === 'information')"
  [class.success]="(state() === 'success')"
  [class.warning]="(state() === 'warning')"
  class="rounded-xs p-4 flex flex-col gap-3">
  <div class="flex flex-col gap-2">
    <div class="flex gap-2 font-semibold">
      <img [src]="Image"/>
      <div>{{content().title}}</div>
    </div>
    @if(content().content) {
      <div>{{content().content}}</div>
    }
  </div>
</div>